/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  SubmitError.js
 */

import { connect } from 'formik'

import { type SubmitErrorProps, useSubmitError } from '../../hooks/useSubmitError'

export const SubmitError = connect<
  Omit<SubmitErrorProps, 'formik'>,
  SubmitErrorProps['formik']['values']
>(({ formik, onSubmitError }: SubmitErrorProps) => {
  useSubmitError({ formik, onSubmitError })
  return null
})
